function initCourseShare() {
  const copyBtn = document.getElementById("copy-share-url");
  if (!copyBtn) return;

  const shareUrl = document.getElementById("share-url");
  const copySuccess = document.getElementById("copy-success");
  const originalHTML = copyBtn.innerHTML;

  copyBtn.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(shareUrl.value);
    } catch {
      const tmp = document.createElement("textarea");
      tmp.value = shareUrl.value;
      document.body.appendChild(tmp);
      tmp.select();
      document.execCommand("copy");
      document.body.removeChild(tmp);
    }

    copySuccess.classList.remove("d-none");
    copyBtn.querySelector("span").textContent = "Kopiert!";

    setTimeout(() => {
      copySuccess.classList.add("d-none");
      copyBtn.querySelector("span").textContent = "Link kopieren";
    }, 3000);
  });
}

document.addEventListener("turbo:load", initCourseShare);
